/**
 * CardEditorPage - Wrapper page for CardEditor component
 *
 * This page handles:
 * - Extracting cardId from URL params
 * - Getting userId and userName from query params or auth context
 * - Rendering the CardEditor component
 * - Supporting both authenticated and guest (anonymous) users
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CardEditor from '../components/CardEditor';

export const CardEditorPage: React.FC = () => {
  const { cardId } = useParams<{ cardId: string }>();
  const [searchParams] = useSearchParams();

  // Get user info from query params (for e2e tests/guest users)
  // This page is designed to work without authentication context
  const userId = searchParams.get('userId') || 'anonymous';
  const userName = searchParams.get('userName') || 'Anonymous User';
  const cardType = searchParams.get('cardType') || 'generic';
  const readOnly = searchParams.get('readOnly') === 'true';

  if (!cardId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-600">Error: Card ID is required</div>
      </div>
    );
  }

  // For now, always render standalone (no Layout) to avoid auth dependencies
  return (
    <div className="card-editor-page h-screen flex flex-col">
      <CardEditor
        cardId={cardId}
        userId={userId}
        userName={userName}
        cardType={cardType}
        readOnly={readOnly}
      />
    </div>
  );
};

export default CardEditorPage;
